export const BASE_ROUTES = {
  associates: "associates",
  bookmarks: "bookmarks",
  comments: "comments",
  plans: "plans",
  filterCategories: "filter-categories",
  inncodeGroups: "inncode-groups",
  cards: "cards",
  notifications: "notifications",
  wizards: "wizards",
  innCodes: "innCodes",
  managementCompany: "management-company",
  ownerGroups: "owner-groups",
  filters: "filters",
  duplicateFilter: "duplicate-filters",
  recentViews: "recent-views",
  viewPlansOverview: "view/plans/overview",
  viewInncodeGroupSummary: "view/inncode-group/summary",
  viewPropertiesSummary: "view/properties/summary",
  viewPlansSummary: "view/plans/summary",
  viewPropertiesOverview: "view/properties/overview",
  feedbacks: "feedbacks",
  suggestedPlans: "suggestedPlans",
  functionalAreas: "functionalAreas",
  legal: "legal",
  feedback: "feedback",
  suggestions: "suggestions",
  recommendations: "recommendations",
  aboveProperty: "above-property",
  pagePreferences: "page/preferences",
  abovePropertyPropertiesPaged: "above-property/properties-paged",
  propertyInfo: "property-info",
  planAssignment: "plan-assignment",
  inncodeInfo: "inncode-info",
  errorLog: "error.log",
  importList: "import-list",
  uploadMatrics: "upload/metrics",
  impersonateAudits: "impersonation-audits",
  metrics: "metrics",
  teamMembersProgress: "team-members/progress",
  associatesMetaData: "associates/metadata",
  resources: "resources",
  userVisitPage: "user-visits/page",
  sharedLink: "shared-link",
  subRegions: "sub-regions",
  brands: "brands",
  multiTarget: "plans/multi-target"
};
